
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
    layout: 'narrow',
    middleware: [
        'home',
        'canAgent'
    ],
    data () {
        return {
            loading: false,
            tableFields: [
                { key: 'shortcuts', sortable: false },
                { key: 'name', sortable: false },
                { key: 'group', sortable: false },
                { key: 'cell_phone', sortable: false },
                { key: 'email', sortable: false },
                // { key: 'group', sortable: false },
            ],
            items: [],
            total: 0,
            form: {
                query: this.$route.query.query || '',
                group: parseInt(this.$route.query.group) || null,
                dups: this.$route.query.dups === 'true',
                marked: this.$route.query.marked === 'true',
                inactive: this.$route.query.inactive === 'true',
                inactive_agent: this.$route.query.inactive_agent === 'true',
                everyrole: this.$route.query.everyrole === 'true',
                by_name: this.$route.query.by_name === 'true',
                page: parseInt(this.$route.query.page) || 1,
                size: parseInt(this.$route.query.size) || 10
            },
            comparing: [],
        }
    },
    fetch () {
        return this.search()
    },
    computed: {
        ...mapGetters([
            'crmBase',
        ]),
    },
    watch: {
        'form.query': {
            deep: true,
            handler: _.debounce(function () {
                this.search({ page: 1 })
            }, 300)
        },
        'form.group' () {
            return this.search({ page: 1 })
        },
        'form.page' () {
            return this.search()
        },
        'form.size' () {
            return this.search({ page: 1 })
        },
        'form.dups' () {
            return this.search({ page: 1 })
        },
        'form.by_name' () {
            return this.search({ page: 1 })
        },
        'form.marked' () {
            return this.search({ page: 1 })
        },
        'form.inactive' () {
            return this.search({ page: 1 })
        },
        'form.inactive_agent' () {
            return this.search({ page: 1 })
        },
        'form.everyrole' () {
            return this.search({ page: 1 })
        },
    },
    mounted () {
        this.$refs.query.focus()
    },
    methods: {
        async search (params = {}) {
            this.loading = true
            params = { ...this.form, ...params }
            if (!params.size) {
                params.size = 100
            }
            params.size = Math.min(params.size, 100)
            this.$routerx.replaceQuery({ ...params, size: params.size })
            const { items, total, page, size } = await this.$try(params.dups ? 'searchDuplicateClients' : 'searchClients', params, { spinner: false })
            this.$routerx.replaceQuery({ page })
            this.items = (items || []).map(this.parseClient)
            this.total = total || 0
            this.form.page = page || 1
            this.form.size = Math.min(size || 10, 100)
            this.loading = false
        },
        parseClient (client) {
            client.name = client.name || this.toName(client)
            return client
        },
    }
}
